import React, { useState } from 'react';
import BuilderStepsNavigation from './Navigation';
import BuilderStepOne from './Step1';
import BuilderStepTwo from './Step2';
import MessageManagerProvider from '../../../../context/messageManager';
import BuilderStepThree from './Step3';
import BuilderStepFour from './Step4';

const builderSteps: { [key: number]: React.ReactNode } = {
  1: <BuilderStepOne />,
  2: <BuilderStepTwo />,
  3: <BuilderStepThree />,
  4: <BuilderStepFour />,
};

function MessageManagerBuilder() {
  const [step, setStep] = useState<number>(1);

  const handleCurrentStep = (payload: number) => {
    setStep(payload);
  };

  return (
    <div className="min-h-calc-min-h-screen-150 grid gap-y-[20px] grid-rows-[64px,1fr]">
      <MessageManagerProvider>
        <BuilderStepsNavigation current={step} total={4} handleCurrentStep={handleCurrentStep} />
        {builderSteps[step]}
      </MessageManagerProvider>
    </div>
  );
}

export default MessageManagerBuilder;
